export const QA_NAME_REQUEST_CREATION_MODAL = 'create_request'
